/* eslint-disable react/destructuring-assignment */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Transition } from 'react-transition-group';
import { useDispatch, useSelector } from 'react-redux';
import { Icon } from '@iconify/react';
import closeIcon from '@iconify/icons-ion/md-close';
import { ExportToCsv } from 'export-to-csv';
import moment from 'utils/moment';
import SectionHeader from '../../../../components/sectionHeader';
import Table from '../../../../components/Table/Table';
import PERMITMODULE from '../../../../icons/PERMITMODULE.png';
import styles from './logs.module.scss';
import styles2 from '../../ADP/Logs/logs.module.scss';
import Filter from '../../ADP/Logs/Filter';
import Button from '../../../../components/button';
import { changeCurrentPage } from '../../../../general_redux/actions';
import { AVP_Re_Print, clearImportState, clearMandatoryDocumentsActions, clearSuccessResponseOfApplicant,
  fetchAvpLogs, fetch_Avp_Permit_Logs_Excel_Export, getAvpDefaultFields,
  getMandatoryDocuments, importAVPlogsData } from '../../redux/action';
import Paginator from '../../../../components/paginator/paginator';
import badgeStyles from '../../../Badging/Detail/detail.module.scss';
import Clickable from '../../../../components/clickable/Clickable';
import FilterForm from '../../components/filterForm/FilterForm';
import Loading from '../../../../components/loading';
import Summary from '../../../../components/DataSummary/Summary';
import Search from '../../../../components/search/Search';
import Forbidden from '../../../Forbidden';
import Modal from '../../../../components/modal';
import { renderInfoForType } from '../../../../utils/helpers';
import { getSelectedTableKeys, getStorageValue, handleLocalStorageColumns } from '../../components/editColumns';

const AvpLogs=(props) => {
  const dispatch=useDispatch();
  const staticColumns = [
    {
      id: 'created_at',
      title: 'Date',
      selected: true,
      dataKey: 'created_at'
    },
    {
      id: 'first_name',
      title: "Applicant's First Name",
      selected: true,
      dataKey: 'first_name'
    },
    {
      id: 'last_name',
      title: "Applicant's Last Name",
      selected: true,
      dataKey: 'last_name'
    },
    {
      id: 'avp_no',
      title: 'Permit Number',
      selected: true,
      dataKey: 'avp_no'
    },
    {
      id: 'avp_validity',
      title: 'Renewal Date',
      selected: false,
      dataKey: 'avp_validity'
    },
    {
      id: 'status',
      title: 'Status',
      selected: true,
      dataKey: 'status'
    }
  ];
  const [page, setPage]=useState(1);
  const [tableKeys, setTableKeys] = useState([]);
  const [state, setState] = useState({
    selectedFilters: [],
    filterPopup: false,
    actionPopup: false
  });
  const [sortKey, setSortKey] = useState('');
  const [filterStatus, setFilterStatus] = useState();
  const [filterCategory, setFilterCategory] = useState([]);
  const [statusOfAdp, setStatusOfAdp]=useState(null);
  const [isExportRequested, setIsExportRequested] = useState(false);
  const [uploadModal, setuploadModal] = useState(false);
  const [excelModal, setExcelModal] = useState(false);
  const [searchQuery, handleSearchQuery] = useState();
  const [filterObject, setFilterObject] = useState({});
  const [confirmModal, setConfirmationModal] = useState(false);
  const [allColumns, setAllColumns] = useState(staticColumns);
  const [filterCategories, setfilterCategories] = useState([]);
  const filterOptions = useSelector(states => states?.permitManagement?.Avp_filteroptions);
  const summary = useSelector(states => states?.permitManagement?.Avp_summary);
  const logs=useSelector(states => states?.permitManagement?.Avp_logs);
  const logsCount=useSelector(states => states?.permitManagement?.totalAvpLogsCount);
  const loader=useSelector(states => states?.permitManagement?.avpInitiationStatus);
  const reprintLoader=useSelector(states => states?.permitManagement?.avpRePrintStatus);
  const enable_initial_review = useSelector(states => states?.permitManagement?.enable_initial_review);
  const profile = useSelector(states => states.auth.profile);
  const settings = useSelector(states => states.permitManagement?.avpSettings);
  const defaultFields = useSelector(states => states.permitManagement?.avpDefaultFields);
  const customFields = useSelector(states => states.permitManagement?.avpCustomFields);
  const hasPermissionToInitiateApplication = useSelector(states => states?.permitManagement?.hasPermissionToInitiateApplication);
  const actionGetMandatoryDocuments = useSelector(states => states?.permitManagement?.actionGetMandatoryDocuments);
  const ordering = useSelector(states => states.permitManagement?.avpOrdering);
  const nomenclature = profile?.permit_management || {};
  const importAvpDataAction = useSelector(states => (states?.permitManagement?.importAvpdataAction));
  const importResponse = useSelector(states => states?.permitManagement?.importResponse);
  const exportToLogsData= useSelector(states => states?.permitManagement?.AvpexcelData);
  const excleLoaderAction= useSelector(states => states?.permitManagement?.AvpexcleLoader);

  const defaultIDs = [
    'first_name', 'last_name', 'phone', 'email', 'category_of_avp', 'purpose_of_vehicle', 'category_of_veh_equp',
    'signature', 'vrea', 'location_of_parking', 'tpaa', 'type_of_veh_equp', 'tpao', 'reg_no_veh_eqpt',
    'pc_validity', 'type_of_issue', 'employee_id', 'make_type', 'veh_powered_by', 'veh_insurance_company',
    'designation', 'insurance_validity', 'year_of_reg', 'company_address', 'length', 'width', 'height'
  ];

  useEffect(() => {
    if (defaultFields && customFields) {
      const allFilteredFields =[...defaultFields, ...customFields].filter(
        field => !['signature', 'header', 'attachments'].includes(field.type)
        && !['first_name', 'last_name'].includes(field.id) && !field.isDisabled
      );
      setAllColumns([...staticColumns, ...allFilteredFields].map(
        each => ({ ...each, title: each.title, dataKey: each.id, id: each.id })
      ));
    }
  }, [defaultFields, customFields]);

  useEffect(() => {
    dispatch(changeCurrentPage(profile?.permit_management?.vehicle_permit || 'AVP'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch(fetchAvpLogs(page, sortKey, filterStatus, undefined, filterCategory));
  }, [dispatch, page, sortKey]);

  useEffect(() => {
    dispatch(getAvpDefaultFields());
  }, [dispatch]);

  useEffect(() => {
    const filters = filterOptions;
    if (filterOptions) {
      const data = [
        {
          id: 1,
          name: 'Status',
          permissions: [{ id: '2', title: 'Pending Approval' },
            { id: '3', title: settings?.badge_status?.[3] || 'Approved' },
            { id: '8', title: settings?.badge_status?.[8] || 'Suspended' },
            { id: '9', title: settings?.badge_status?.[9] || 'Revoked' },
            { id: '4', title: 'Rejected' },
            { id: '5', title: 'Expired' },
            { id: '7', title: 'Cancelled' },
            { id: '14', title: 'Draft' },
            { id: '30', title: 'Expiring in 30 days' },
            { id: '60', title: 'Expiring in 60 days' },
            { id: '90', title: 'Expiring in 90 days' },
            { id: '1', title: 'Pending Applicant Details' },
            { id: '15', title: 'Application Withheld' },
            { id: '0', title: 'Training Pending' },
            { id: '18', title: 'Re Verify Documents' },
            { id: '26', title: 'Re Print Request' }]
        },
        {
          id: 2,
          name: `${nomenclature?.vehicle_permit || 'AVP'} Category`,
          permissions: [...filters?.category_of_avp?.map(ele => ({ id: ele, title: ele }))]

        }
      ];
      if (enable_initial_review) {
        const newStatus = data[0]?.permissions;
        newStatus.unshift({ id: '6', title: 'Pending Review' });
        data[0].permissions = newStatus;
      }
      setfilterCategories(data);
    } else {
      setfilterCategories([
        {
          id: 1,
          name: 'Status',
          permissions: []
        }
      ]);
    }
  }, [filterOptions, enable_initial_review]);


  useEffect(() => {
    if (!allColumns?.length) {
      return;
    }

    const savedColumns = getStorageValue('AvpColumns');
    const savedTableKeys = getStorageValue('AvptableKeys');
    const newColumns = handleLocalStorageColumns(allColumns, savedColumns, savedTableKeys);
    const data = getSelectedTableKeys(newColumns);

    setTableKeys(data);
    localStorage.setItem('AvpColumns', JSON.stringify(newColumns));
  }, [allColumns]);

  useEffect(() => {
    if (importAvpDataAction.success || importAvpDataAction.error) {
       setExcelModal(false);
       dispatch(clearImportState());
       if (importAvpDataAction.success) {
         setConfirmationModal(true);
       }
    }
   }, [importAvpDataAction, dispatch]);

  useEffect(() => {
    if (isExportRequested && exportToLogsData?.length > 0 && excleLoaderAction?.success) {
      exportToExcel();
      setIsExportRequested(false);
    }
  }, [exportToLogsData, isExportRequested]);


  useEffect(() => {
    if (actionGetMandatoryDocuments?.success && hasPermissionToInitiateApplication) {
      // AVAIABLE DOCUMENTS ARE CORRECT, THEN WILL GO TO INITIATE APPLICATION.
      dispatch(clearMandatoryDocumentsActions(false));
      dispatch(clearSuccessResponseOfApplicant());
      props.history.push('/avp/initiate/application');
    }
  }, [hasPermissionToInitiateApplication, actionGetMandatoryDocuments]);

  const changePage =(pageNo) => {
    setPage(pageNo);
  };
  const handelFilter = (data) => {
    const status = [];
    let category_of_avp = data?.[`${nomenclature?.vehicle_permit || 'AVP'} Category`]
          ? data?.[`${nomenclature?.vehicle_permit || 'AVP'} Category`].join()
          : false;

    if (data.Status) {
      filterCategories[0].permissions.forEach((ele) => {
        data.Status.forEach((el) => {
          if (ele.title === el && enable_initial_review && el === 'Pending Approval') {
            status.push('6');
          } else if (ele.title === el && enable_initial_review && el === 'Pending Review') {
            status.push('2');
          } else if (ele.title === el) {
            status.push(ele.id);
          }
        });
      });
    }
    setFilterStatus(status);
    setFilterCategory(category_of_avp);
    setStatusOfAdp(Number(status[0]));
    dispatch(fetchAvpLogs(1, sortKey, status, undefined, category_of_avp));
    const filters = {
      category_of_avp: category_of_avp?.length === 0 ? false : category_of_avp
    };
    let filter_Object = {};

    if (category_of_avp) {
      let element = '';
      const key = `${nomenclature?.vehicle_permit || 'AVP'} Category`;
      if (Array.isArray(category_of_avp)) {
        element = category_of_avp;
      } else {
        element = category_of_avp?.includes(',') ? category_of_avp?.split(',') : [category_of_avp];
      }
      filter_Object = { ...filter_Object, [key]: element };
    }

    if (status?.length !== 0 && status !== false) {
      let element = '';
      if (Array.isArray(status)) {
        element = status;
      } else {
        element = status?.includes(',') ? status?.split(',') : [status];
      }
      filter_Object = { ...filter_Object, 'Status': element };
    }

    localStorage.setItem('AVPFilters', JSON.stringify(filters));
    if (Object.keys(filter_Object).length === 0) {
      setFilterObject(filter_Object);
    } else {
      setFilterObject(data);
    }
  };
  const handelUpdateFilters = (filterValues, filter_object) => {
    handelFilter(filter_object);
    setState({ ...state, selectedFilters: filterValues, filterPopup: !state.filterPopup });
  };
  const handleFilterDropdown = () => {
    setState({ ...state, filterPopup: !state.filterPopup });
  };
  const slideStyles = {
    entered: { transform: 'translate3d(0px,0px)' }
  };
 const handleSort = (newSort) => {
    setSortKey(newSort);
  };
  const handleRemoveFilterFunction = (value) => {
    setState({ ...state, selectedFilters: state.selectedFilters.filter(ele => ele !== value) });
    handleRemoveFilter(value);
  };

  const handleRemoveFilter = (value) => {
    let result = {};
    result = Object.entries(filterObject).reduce((acc, [key, arr]) => {
      acc[key] = arr.includes(value)
        ? arr.filter(ele => ele !== value)
        : arr;
      return acc;
    }, {});

    let category_of_avp = result?.[`${nomenclature?.vehicle_permit || 'AVP'} Category`]?.length !== 0
      ? result?.[`${nomenclature?.vehicle_permit || 'AVP'} Category`]
      : false;
    let status = result?.Status?.length !== 0 ? [] : false;
    if (Array.isArray(result?.Status)) {
      filterCategories[0].permissions.forEach((ele) => {
        result.Status.forEach((el) => {
          if (ele.title === el && enable_initial_review && el === 'Pending Review') {
            status.push('2');
          } else if (ele.title === el && enable_initial_review && el === 'Pending Approval') {
            status.push('6');
          } else if (ele.title === el) {
            status.push(ele.id);
          }
        });
      });
    }
    let flag = false;
    Object.keys(result).forEach((ele) => {
      if (flag === false) {
        if (result[ele].length === 0) {
          flag = false;
        } else { flag = true; }
      }
    });

    if (!flag) {
      localStorage.setItem('avp_page', 1);
      dispatch(fetchAvpLogs(1, sortKey, undefined, undefined, undefined));
      setFilterObject({ ...filterObject, Status: [], 'Application Type': [], 'License Type': [], Company: [] });
      const filters = {
        status: false,
        category_of_avp: category_of_avp?.length === 0 ? false : category_of_avp };
      localStorage.setItem('AVPFilters', JSON.stringify(filters));
    } else {
      localStorage.setItem('avp_page', 1);
      dispatch(fetchAvpLogs(1, sortKey,
        status.length === 0 ? false : status, undefined, category_of_avp));
      const filters = {
        category_of_avp: category_of_avp?.length === 0 ? false : category_of_avp
      };
      localStorage.setItem('AVPFilters', JSON.stringify(filters));
      setFilterObject(result);
    }
  };
  const handleStatusFilter = (value) => {
    handelFilter({ Status: [value] });
    setState({ ...state, selectedFilters: [value] });
  };
  const handelReprint = (id) => {
    dispatch(AVP_Re_Print(id));
  };

  const onSubmitSearch = (value) => {
    handleSearchQuery(value);
    dispatch(fetchAvpLogs(page, sortKey, filterStatus, value, filterCategory));
  };

  const handleActionPopup = () => {
    setState({ ...state, actionPopup: !state.actionPopup });
  };

  const columnData = (cols) => {
    const selectedTableKeys = cols
      ?.filter(column => column.selected === true)
      ?.map(column => [column.dataKey, column.title]) || [];
    const newColumns = handleLocalStorageColumns(allColumns, cols, selectedTableKeys);
    const data = getSelectedTableKeys(newColumns);
    setTableKeys(data);
    localStorage.setItem('AvpColumns', JSON.stringify(newColumns));
    localStorage.setItem('AvptableKeys', JSON.stringify(data));
  };

  const tags = [
    ['Pending Review', 'pending_approval', 'rgb(254,247,229)', '#3c62a8'],
    ['Pending Approval', 'reviewed', 'rgb(254,247,229)', 'rgb(247,186,96)'],
    ['Pending Approval', 'pending_approval', 'rgb(254,247,229)', 'rgb(247,186,96)'],
    [settings?.badge_status?.[3] || 'Approved', 'approved', 'rgb(239,250,227)', 'rgb(113,215,88)'],
    [settings?.badge_status?.[8] || 'Suspended', 'suspended', 'rgb(128, 128, 128)', 'rgb(128, 128, 128)'],
    [settings?.badge_status?.[9] || 'Revoked', 'revoked', '#404040', '#404040'],
    ['Rejected', 'rejected', 'rgb(255, 87, 51 )', 'rgb(255, 87, 51 )'],
    ['Expired', 'expired', 'rgb(128, 128, 128)', 'rgb(128, 128, 128)'],
    ['Cancelled', 'cancelled', '#404040', '#404040'],
    ['Expiring in 30 days', 'expiring_in_thirty_days', 'rgb(255, 87, 51 )', 'rgb(255, 87, 51 )'],
    ['Re Print Request', 'reprint', 'rgb(254,247,229)', 'rgb(247,186,96)']
  ];
  const handleTags = (usedTags) => {
    const newTags = usedTags;
    if (enable_initial_review) {
      if (newTags[2][1] === 'pending_approval') {
        newTags.splice(2, 1);
      }
    } else if (!enable_initial_review) {
      if (newTags[0][1] === 'pending_approval' && newTags[1][1] === 'reviewed') {
        newTags.splice(0, 2);
      }
    }
    return newTags;
  };

  const toggleUploadModal = (val) => {
    setuploadModal(!uploadModal);
    if (val) {
      toggleExcelModal();
    }
  };

  const toggleExcelModal = (val) => {
    if (val) {
      dispatch(importAVPlogsData({ permits_data: val }));
    } else {
      setExcelModal(!excelModal);
    }
  };

  const getStatus = (ele) => {
    if (Number(ele) === 2 && enable_initial_review) {
      return 'Pending Review';
    }
    if ((Number(ele) === 6 && enable_initial_review)
        || (Number(ele) === 2 && !enable_initial_review)) {
      return 'Pending Approval';
    }
    if (ele === 0) {
      return 'Training Pending';
    } if (ele === 1) {
      return 'Pending Applicant Details';
    } if ((ele === 2 || ele === 6) && enable_initial_review) {
      return 'Pending Approval';
    } if (ele === 3) {
      return (settings?.badge_status?.[3] || 'Approved');
    } if (ele === 4) {
      return 'Rejected';
    } if (ele === 7) {
      return 'Cancelled';
    } if (ele === 5) {
      return 'Expired';
    } if (Number(ele) === 30) {
      return 'Expiring in 30 days';
    } if (Number(ele) === 60) {
      return 'Expiring in 60 days';
    } if (Number(ele) === 90) {
      return 'Expiring in 90 days';
    } if (Number(ele) === 180) {
      return 'Expiring in 180 days';
    } if (Number(ele) === 365) {
      return 'Expiring in 365 days';
    } if (Number(ele) === 26) {
      return 'Re Print Request';
    } if (Number(ele) === 8) {
      return (settings?.badge_status?.[8] || 'Suspended');
    } if (Number(ele) === 11) {
      return 'Pending Schedule';
    } if (Number(ele) === 9) {
      return (settings?.badge_status?.[9] || 'Revoked');
    } if (Number(ele) === 10) {
      return 'Payment Pending';
    } if (Number(ele) === 14) {
      return 'Draft';
    } if (Number(ele) === 15) {
      return 'Application Withheld';
    } if (Number(ele) === 18) {
      return 'Re Verify Documents';
    } return null;
  };
    const finalData = (info, columnsArray) => info?.map((e) => {
      const obj = {};
      columnsArray.forEach((col) => {
        let value = e[col?.dataKey];
        if (col.id?.includes('custom-')) {
          value = e.response[col?.dataKey] || '';
        } else if (
          col?.dataKey?.includes('created_at')
          || col?.dataKey?.includes('date')
          || col?.dataKey?.includes('approved_on')
          || col?.dataKey?.includes('suspended_at')
        ) {
          value = value ? renderInfoForType({ type: 'datetime', format: localStorage?.getItem('dateFormat') || 'MM/DD/YYYY' },
          value, null, null) : '';
        } else if (col?.dataKey?.includes('status')) {
          value = getStatus(Number(value));
        } else if (col?.dataKey==='activated_by') {
        value= e?.re_activated_by || '';
      }
        obj[col?.title] = value === null ? '' : value;
      });
      obj['Total Payment'] = e.total_amount === null ? '' : `${profile?.portal_airport?.airport_settings?.currency}${e.total_amount}`;
      return obj;
    });

  const fetchExcle = async () => {
    setIsExportRequested(true);
    let status = [];
    let avpCategoryList = [];
    filterCategories[0].permissions.forEach((ele) => {
      if (filterObject?.Status?.length > 0) {
          filterObject.Status.forEach((el) => {
            if (ele.title === el && enable_initial_review && el === 'Pending Approval') {
              status.push('6');
            } else if (ele.title === el && enable_initial_review && el === 'Pending Review') {
              status.push('2');
            } else if (ele.title === el) {
              status.push(ele.id);
            }
          });
      }
        });

    filterCategories[1].permissions.forEach((ele) => {
    if (filterObject?.[`${nomenclature?.vehicle_permit || 'AVP'} Category`]?.length > 0) {
      filterObject[`${nomenclature?.vehicle_permit || 'AVP'} Category`].forEach((el) => {
        if (ele.title === el) {
          avpCategoryList.push(el);
        }
      });
      }
    });
    dispatch(fetch_Avp_Permit_Logs_Excel_Export(undefined, searchQuery, status, avpCategoryList));
  };

  const exportToExcel = () => {
    const options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: false,
      showTitle: false,
      title: 'Avp Data',
      useTextFile: false,
      filename: `${profile?.portal_airport?.code}_Avp-Data`,
      useBom: true,
      useKeysAsHeaders: true
    };
    const csvExporter = new ExportToCsv(options);

    if (exportToLogsData) {
      if (exportToLogsData.length!==0) {
        finalData(exportToLogsData, allColumns);
        csvExporter.generateCsv(finalData(exportToLogsData, allColumns));
    }
    handleActionPopup();
  }
  };
  const downloadCSVTemplate = () => {
    const csvData= [];
    const dataWithType=[
            { string: 'sample',
          number: 1,
          date: moment(new Date()).format('YYYY-MM-DD'),
          telephone: 1234567890,
          company: profile?.current_tenant?.name,
          boolean: true
      },
      { string: 'sample',
          number: 2,
          date: moment(new Date()).format('YYYY-MM-DD'),
          telephone: 1234567890,
          company: profile?.current_tenant?.name,
          boolean: false
      },
      { string: 'sample',
          number: 3,
          date: moment(new Date()).format('YYYY-MM-DD'),
          telephone: 1234567890,
          company: profile?.current_tenant?.name,
          boolean: true
      }];
    dataWithType.forEach((d) => {
      const tempObj = {};
      tempObj.Company = d.company;
      ordering.forEach((orderId) => {
        if (!defaultIDs.includes(orderId)) {
          const field = customFields.find(f => f.id === orderId);
          if (field.type !== 'header' && field.type !== 'attachments') {
            if (field.type === 'select') {
              tempObj[field.title] = field.values[0].key;
            } else {
              tempObj[field.title] = d[field.type === 'datetime' ? 'date' : field.type];
            }
          }
        } else {
          const field = defaultFields.find(f => f.id === orderId);
          if (!field.isDisabled && field.type !== 'signature') {
            if (field.type === 'select') {
              tempObj[field.title] = field.values[0].key;
            } else if (field.id === 'year_of_reg') {
              tempObj[field.title] = 2025;
            } else {
              tempObj[field.title] = d[field.type];
            }
          }
        }
      });
         if (tempObj["Applicant's First Name"]) {
          tempObj["Applicant's First Name"] = profile?.first_name || 'sample';
      }
      if (tempObj["Applicant's Last Name"]) {
          tempObj["Applicant's Last Name"] = profile?.last_name || 'sample';
      }
      if (tempObj["Applicant's Phone Number"]) {
          tempObj["Applicant's Phone Number"] = profile?.phone || '1234567890';
      }
      if (defaultFields) {
          defaultFields.forEach((ele) => {
          const normalKey = ele.title;
          const asteriskKey = `*${normalKey}`;
          const existingValue = tempObj[normalKey] ?? tempObj[asteriskKey];
          delete tempObj[normalKey];
          delete tempObj[asteriskKey];

          if (existingValue !== undefined) {
            if (ele.required) {
              tempObj[asteriskKey] = existingValue;
            } else {
              tempObj[normalKey] = existingValue;
            }
          }
          });
        }
          if (customFields) {
          customFields.forEach((ele) => {
          const normalKey = ele.title;
          const asteriskKey = `*${normalKey}`;
          const existingValue = tempObj[normalKey] ?? tempObj[asteriskKey];
          delete tempObj[normalKey];
          delete tempObj[asteriskKey];
          if (existingValue !== undefined) {
            if (ele.required) {
              tempObj[asteriskKey] = ele.default_text || '';
              if (ele.type !== 'header' && ele.type !== 'attachments') {
            if (ele.type === 'select') {
              tempObj[asteriskKey] = ele.values[0].key;
            } else {
              tempObj[asteriskKey] = d[ele.type === 'datetime' ? 'date' : ele.type];
            }
          }
            } else {
              tempObj[normalKey] = ele.default_text || '';
            }
          }
          });
        }
        csvData.push(tempObj);
      });

    const options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: true,
      showTitle: false,
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: true,
      filename: 'AVPLogs'
    };
    function moveFieldsToLast(renderedData, fieldsToMoveLast) {
      return renderedData.map((item) => {
        const rest = Object.keys(item)
          .filter(key => !fieldsToMoveLast.includes(key))
          .reduce((acc, key) => ({ ...acc, [key]: item[key] }), {});

        const lastFields = fieldsToMoveLast.reduce((acc, key) => {
          if (key in item) {
            return { ...acc, [key]: item[key] };
          }
          return acc;
        }, {});
        return { ...rest, ...lastFields };
      });
    }
    const csvExport = new ExportToCsv(options);
    const fieldsToMoveLast = ['Company', "Applicant's First Name", "Applicant's Last Name", "Applicant's Phone Number"];
    function addAsteriskToKeys(data, keysToModify) {
  return data.map((item) => {
    const newItem = {};
    Object.entries(item).forEach(([key, value]) => {
      if (keysToModify.includes(key)) {
        newItem[`*${key}`] = value;
      } else {
        newItem[key] = value;
      }
    });
    return newItem;
  });
}
    const reorderedData = moveFieldsToLast(csvData, fieldsToMoveLast);
    const finalizedData = addAsteriskToKeys(reorderedData, fieldsToMoveLast);
    csvExport.generateCsv(finalizedData);
  };


  const checknMandatoryDocuments = (tenantId) => {
    // THIS API WILL CHECK THE DOCUMENTS FOR THE TENANT,
    // WITH VALID ATTACHMENT AND Mandatory document required for permit application CHECKBOX IS ENABLED;
    dispatch(getMandatoryDocuments(tenantId));
  };
  // IMPORT AVP RECORDS BASED ON THESE TYPES ONLY, OTHER TYPES ARE IGNORED
  const allowFieldTypes = ['string', 'number', 'date', 'datetime', 'select', 'telephone'];

  return <>
    <Loading loadingStatus={loader.loading || reprintLoader.loading || excleLoaderAction?.loading || actionGetMandatoryDocuments?.loading} />
    <SectionHeader icon={PERMITMODULE} translationID=" " defaultTitle={profile?.permit_management?.vehicle_permit || 'AVP'} centered {...props}>
      <div className={styles.detailHeader} />
      <Search onSubmit={e => onSubmitSearch(e)} />
        {profile?.permissions?.vehicle_permit?.includes('add_vehiclepermit')
        &&<Button
            action="primary"
            // onClick={() => (props.history.push('/avp/initiate/application'))}
            onClick={() => checknMandatoryDocuments(profile?.current_tenant?.id)}
            translationID="avp.Initieate"
            defaultText="Initiate Application"
          />
        }
    </SectionHeader>
    {profile?.permissions?.vehicle_permit.includes('view_vehiclepermit')
    ?<>
      <div style={{ display: 'flex' }} className={styles.toolbar}>
        <div className={styles.counter}>
          <FormattedMessage id="avp.list.open" defaultMessage={`All Permits (${logsCount ?? 0})`} />
        </div>
        <Filter
        editColumns="AvpColumns"
        handleActionPopup={handleActionPopup}
        actionPopup={state.actionPopup}
        showAction
        columnData={columnData}
        filterCategories={filterCategories}
        handleDropdown={handleFilterDropdown}
        actionPostion
        defaultColumns={allColumns}
        user={profile}
        toggleUploadModal={toggleUploadModal}
        toggleExcelModal={toggleExcelModal}
        downloadCSVTemplate={downloadCSVTemplate}
        excelModal={excelModal}
        uploadModal={uploadModal}
        fieldsForMapping={[
          ...(defaultFields && Array.isArray(defaultFields) ? defaultFields.filter(field => !field.isDisabled && allowFieldTypes.includes(field.type))
          .map((filterField) => {
            if (filterField.id === 'first_name' || filterField.id === 'last_name') {
              return { ...filterField, required: true };
            }
            return filterField;
          }) || [] : []),
          ...(customFields?.filter(field => !field.isDisabled && allowFieldTypes.includes(field.type)) || []),
          { id: 'company', title: 'company', required: true }]}
        exportToExcel={fetchExcle}
      />
      </div>
      {state.selectedFilters.length !== 0 && (
        <div className={styles2.filter}>
          {state?.selectedFilters?.map((category) => {
            if (category?.length !== 0 && category) {
              return (
                <span className={styles2.user} key={category}>
                  {category}
                  <span onKeyPress={() => handleRemoveFilterFunction(category)} tabIndex={0} role="button"
                    onClick={() => handleRemoveFilterFunction(category)} className={styles2.btnRemove}
                  />
                </span>);
            } return null;
          })}
        </div>)}
      <div className={styles.container}>
        <div className={styles.info} style={{ display: 'block' }}>
          <Summary tags={handleTags(tags)} data={summary} handleStatusFilter={handleStatusFilter} enable_initial_review={enable_initial_review} />
        </div>
      </div>
      <div style={{ marginTop: '2vw' }}>
        <Table tableHeadders={tableKeys} logs={logs} route="/avp" {...props} avp handelReprint={handelReprint}
          enable_initial_review={enable_initial_review || false} settings={settings}
           sortKey={sortKey}// send false to hide sortKey
        setSortKey={handleSort}// send false to hide sort function
        />
        {logsCount!==0 && (
        <div className={styles.paginatorContainer}>
          <Paginator
            page={1}
            totalRecords={logsCount}
            pageLimit={20}
            pageNeighbours={1}
            onPageChanged={(pageNo) => { changePage(pageNo); }}
          />
        </div>
        )}
      </div>
      {/* IF AVAIALABLE DOCUMENTS ARE NOT APPROVED, THEN WE ARE GOING RESTRICT THE USER TO INITIATE APPLICATION
        AND WILL SHOW THE RELATED WARNING MESSAGE */}
      {!hasPermissionToInitiateApplication && (
        <Modal
          showIn={!hasPermissionToInitiateApplication}
          onClose={() => dispatch(clearMandatoryDocumentsActions(true))}
          width="500px"
          minHeight="20%"
          centered
        >
          <div className={badgeStyles.newTask}>
            <div className={badgeStyles.closeicon}
             style={{ padding: '15px 15px 15px 15px' }}
            >
              <FormattedMessage
                tagName="h4"
                id="adp.log.suspend.application"
                defaultMessage={'Start Application'}
              />
              <Clickable onClick={() => dispatch(clearMandatoryDocumentsActions(true))}>
                <div style={{ cursor: 'pointer' }}>X</div>
              </Clickable>
            </div>
            <div className={styles.subHeading} style={{ fontWeight: '500' }}>
            <div>
              <FormattedMessage
                id="avp_mandatory_documents_not_approved"
                tagName="h5"
                defaultMessage={'Mandatory documents are not approved. Please initiate an application after approval.'}
              />
            </div>
            </div>
          </div>
        </Modal>
      )}
      {state.filterPopup && (
        <Transition in={state.filterPopup} timeout={200} unmountOnExit>
          <FilterForm
            transition={slideStyles}
            update={handelUpdateFilters}
            cancel={handleFilterDropdown}
            selectedFilters={state.selectedFilters}
            filter_Categories={filterCategories}
            filter_Object={filterObject}
            filterPostion
          />
        </Transition>
      )}
     </>
    :<Forbidden />
    }{confirmModal && !importResponse?.error
      && <div>
            <Modal showIn={confirmModal} width="554px" minHeight="25%"
            onClose={() => { setConfirmationModal(false); dispatch(fetchAvpLogs(page)); }}>
              <div className={styles.modalHeader}>
                <div className={styles.modalTitle}>
                  <FormattedMessage
                    id="apv.recordsSummary"
                    defaultMessage="Records Summary"
                  />
                </div>
                <div className={styles.iconGroup}>
                  <Icon
                    icon={closeIcon}
                    onClick={() => { setConfirmationModal(false); dispatch(fetchAvpLogs(page)); }}
                    height="20"
                    style={{ cursor: 'pointer' }}
                  />
                </div>
              </div>
              <div className={styles.modelBody}>
                <div className={styles.innerDiv}>
                  <span className={styles.createdInfo}>
                    <FormattedMessage id="avp.totalRecords" defaultMessage="Total Records Uploaded" />
                    {' '}:{' '}
                    <span className={styles.number}>
                      {+importResponse['total records created'] + +importResponse['total records not created']}
                    </span>
                  </span>
                  <span className={styles.createdInfo}>
                    <FormattedMessage id="avp.createedRecords" defaultMessage="Total Records Created" />
                    {' '}:{' '}
                    <span className={styles.number}>
                      {importResponse['total records created']}
                    </span>
                  </span>
                  <span className={styles.createdInfo}>
                    <FormattedMessage id="avp.recordsNotCreated" defaultMessage="Total Records Not Created" />
                    {' '}:{' '}
                    <span className={styles.number}>
                      {importResponse['total records not created']}
                    </span>
                  </span>
                </div>
              </div>
              <div className={styles.modelFooter}>
              <Button
                onClick={() => { setConfirmationModal(false); dispatch(fetchAvpLogs(page)); }}
                type="submit"
                translationID="inspections.list.ok"
                defaultText="OK"
                action="secondary"
              />
              </div>
            </Modal>
         </div>}
         </>;
};

export default AvpLogs;
